<template>
  <section class="section groupInfo" :class="{open: show}"
    v-on:click="sectionClicked">
    <transition name="fade">
      <div class="leftBackdrop" v-if="show"
        v-on:click="close"></div>
    </transition>
    <div class="rightContent">
      <div class="tree"></div>
      <div class="rightContentIn">
        <div class="header">
          <div class="backBtn" v-on:click="close"></div>
          <h4>Info Grup</h4>
        </div>
        <div class="contentSc" v-if="group">
          <div class="groupProfile">
            <div class="profilePict" :class="{noImg: !group.avatar || group.avatar === ''}"
              :style="{'background-image': `url(${group.avatar})`}"></div>
            <h4>{{group.name}}</h4>
          </div>
          <div class="groupMenu">
            <div class="menuItem hasToggle" v-on:click="muteGroup">
              <div class="menuIcon notif"></div>
              <span>Turn off notifications</span>
              <div class="toggle">
                <div class="radioItem" :class="{on: group.muted === 1}">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h4 class="sectionTitle">Invite member</h4>
          <form v-on:submit.prevent="findUser">
            <div class="fieldGroup">
              <div class="fieldCnt findUser" :class="{hasError: userError}">
                <input type="text" class="field" v-model="userModel"
                  v-on:input="userError = false" placeholder="Find user...">
                <button type="submit" :class="{loading: findingUser}"></button>
                <div class="fieldError" v-if="userError">{{userError}}</div>
                <div class="hint" v-else>Cari dengan Email/No. Telp.</div>
              </div>
            </div>
          </form>
          <h4 class="sectionTitle">Group Members</h4>
          <div class="groupMembers">
            <div class="memberItem" v-for="(item, i) of group.members"
              :key="`gmd${i}`">
              <div class="avatar" :class="{noImg: !item.avatar || item.avatar === ''}"
                :style="{'background-image': `url(${item.avatar})`}"></div>
              {{item.user.name}}
              <div class="kick" v-on:click="kickMember(i, item)"></div>
            </div>
          </div>
          <div class="groupMenu">
            <div class="menuItem red" :class="{menuLoading: loading}" v-on:click="leaveGroup">
              <div class="menuIcon"></div>
              <span>Leave group</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'chatGroupDetail',
  components: { Confirmation },
  data() {
    return {
      show: false,
      next: null,
      group: null,
      loading: false,
      userError: null,
      userModel: '',
      findingUser: false,
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    open(d, n) {
      this.next = n;
      this.group = d;
      this.show = true;
      this.loading = false;
    },
    kickMember(i, item) {
      this.$refs.confirmDialog.open({
        title: `Keluarkan ${item.name} Dari Grup`,
        desc: `Apakah kamu yakin ingin mengeluarkan ${item.name} dari grup ini?`,
        action: 'Keluarkan',
      }, (b) => {
        if (!b) return;
        this.group.members.splice(i, 1);
        this.$http.get(this.$config.uri(`group/member/${item.id}/kick`));
      });
    },
    muteGroup() {
      const title = (this.group.muted === 1) ? 'Nyalakan Notifikasi' : 'Matikan Notifikasi';
      const desc = (this.group.muted === 1)
        ? 'Jika kamu menyalakan notifikasi untuk grup ini, akan ada suara ketika ada pesan baru.'
        : 'Jika kamu mematikan notifikasi untuk grup ini, tidak akan ada suara ketika ada pesan baru.';
      this.$refs.confirmDialog.open({ title, desc, action: title }, (b) => {
        if (!b) return;
        const muteUri = (this.group.muted === 1) ? 'unmute' : 'mute';
        this.group.muted = (this.group.muted === 1) ? 0 : 1;
        this.$http.get(this.$config.uri(`group/${this.group.id}/${muteUri}`));
      });
    },
    findUser() {
      this.findingUser = true;
      this.$http.post(this.$config.uri('user/find'), {
        user: this.userModel,
      }).then((r) => {
        this.findingUser = false;
        if (r.data.status !== 200) {
          this.userError = 'Peserta tidak ditemukan';
          return;
        }
        this.userModel = '';
        // eslint-disable-next-line
        for (const m of this.group.members) {
          if (m.user.id === r.data.data.id) {
            this.userError = 'Peserta sudah terdaftar';
            return;
          }
        }
        this.$http.post(this.$config.uri(`group/${this.group.id}/member/add`), {
          userId: r.data.data.id,
        }).then((r2) => {
          this.group.members.push({ id: r2.data.id, user: r.data.data });
        });
      });
    },
    leaveGroup() {
      if (this.loading) return;
      this.$refs.confirmDialog.open({
        title: 'Keluar Dari Grup',
        desc: `Apakah kamu yakin ingin keluar dari grup ini?
          Grup dan isi percakapan akan dihapus dari daftar grup kamu.`,
        action: 'Keluar Grup',
      }, (b) => {
        if (!b) return;
        this.loading = true;
        this.$http.get(this.$config.uri(`group/${this.group.id}/leave`)).then(() => {
          this.close(true, { type: 'leave' });
        });
      });
    },
    close(b, v) {
      this.show = false;
      if (this.next) this.next(b, v);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.section.groupInfo{
  position: fixed;
  right: 0; top: 0; bottom: 0;
  left: auto;
  padding: 0;
  z-index: 9997;
  .rightContent{
    position: fixed;
    right: 0; top: 0; bottom: 0;

    background-color: #fff;
    // background-color: #e6e1c1;
    // background-color: #b7e4c9;
    // background-image: linear-gradient(#fff 0, #e2fcec 50%, #fff);

    padding: 0 0 40px;
    box-sizing: border-box;
    width: 480px;
    z-index: 3;
    right: -480px;
    transition: all .42s ease;
    @media (max-width: 680px) {
      width: 96%; right: -96%;
    }
    .tree{
      position: absolute;
      left: 0; right: -10px; bottom: 0; top: 0;
      // background-image: url(../assets/high-five.png);
      background-size: auto 160px;
      background-position: 95% 100%;
      background-repeat: no-repeat;
    }
  }
  .leftBackdrop{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    // background-color: #000;
    background-color: rgba(0,0,0,.36);
    z-index: 1;
    transition: all .3s ease;
  }
  &.open{
    .rightContent{
      right: 0;
    }
  }
  .header{
    position: relative;
    padding: 0 20px;
    height: 60px;
    display: flex;
    align-items: center;
    z-index: 7;
    box-shadow: 0 0 4px rgba(0, 0, 0, .2);
    backdrop-filter: blur(20px);
    .backBtn{
      width: 40px; height: 40px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-next-black.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    h4{
      font-size: 18px;
      margin: 0;
      color: #444;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: auto;
      padding: 0 10px 0 20px;
    }
  }
  .contentSc{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    overflow-y: auto;
    z-index: 5;
    padding: 70px 10px 10px;
    box-sizing: border-box;
  }
  .groupProfile{
    text-align: center;
    padding: 20px 0;
    .profilePict{
      width: 160px; height: 160px;
      background-size: cover;
      background-color: #fff;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 50%;
      margin: 0 auto 10px;
      &.noImg{
        background-image: url(../assets/image-black.png) !important;
        background-size: 46px auto;
        opacity: .35;
      }
    }
    h4{
      margin: 0;
      font-size: 24px;
    }
  }
  .sectionTitle{
    font-size: 13px;
    text-transform: uppercase;
    font-weight: 600;
    opacity: .45;
    color: #000;
    margin: 20px 20px 6px;
  }
  .groupMembers{
    margin: 0 -10px;
    .memberItem{
      padding: 5px 20px;
      font-weight: bold;
      display: block;
      color: #444;
      position: relative;
      z-index: 3;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .kick{
        margin-left: auto;
        width: 30px; height: 30px;
        background-color: rgba(0, 0, 0, .1);
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 10px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .56;
        margin-right: 6px;
        cursor: pointer;
      }
      .avatar{
        width: 44px; height: 44px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        background-color: #fff;
        border-radius: 50%;
        margin-right: 14px;
        &.noImg{
          background-image: url(../assets/image-black.png) !important;
          background-size: 18px auto;
          opacity: .35;
        }
      }
    }
  }
  .fieldGroup{
    padding: 0 10px;
    h4{
      font-size: 16px;
    }
    .fieldCnt.findUser{
      position: relative;
      button{
        position: absolute;
        right: 4px; top: 4px;
        width: 38px; height: 38px;
        border: none;
        padding: 0;
        border-radius: 3px;
        z-index: 3;
        cursor: pointer;
        background-image: url(../assets/search-white.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        transition: all .3s ease;
        background-color: #5351a4;
        &:hover{
          background-color: #615fb1;
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
        }
        &.loading{
          background-color: #eee;
          background-image: url(../assets/loading.svg);
          background-size: 28px auto;
          cursor: default;
          box-shadow: none;
        }
      }
    }
  }
  .groupMenu{
    margin-top: 40px;
    .menuItem{
      padding: 16px 20px;
      padding-left: 56px;
      font-weight: bold;
      display: block;
      color: #444;
      position: relative;
      background-color: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(20px);
      margin: 0 10px 6px;
      border-radius: 5px;
      font-size: 17px;
      transition: all .3s ease;
      cursor: pointer;
      display: flex;
      align-items: center;
      &.hasToggle{
        padding: 10px 20px;
        padding-left: 56px;
      }
      &.red{
        color: #fe3126;
      }
      &:hover{
        background-color: rgba(255, 255, 255, .8);
      }
      .toggle{
        margin: 0;
        margin-left: auto;
        width: 50px; height: 30px;
      }
      .menuIcon{
        position: absolute;
        left: 20px; top: 16px;
        width: 20px; height: 20px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        opacity: .9;
        background-image: url(../assets/logout-red.png);
        &.notif{
          background-image: url(../assets/notifications_off_black_24dp.svg);
          width: 26px; height: 26px;
          left: 17px; top: 10px;
          opacity: .76;
        }
      }
      &.menuLoading{
        background-image: url(../assets/loading.svg);
        background-size: 30px auto;
        background-position: center;
        background-repeat: no-repeat;
        cursor: default;
        box-shadow: none;
        background-color: #ccc;
        .menuIcon, span{
          visibility: hidden;
        }
      }
    }
  }
}
</style>
